import { API_URL } from '@/config';
import FetchClient, { HttpClient } from './fettchClient';

export const api = new HttpClient(API_URL); //new FetchClient(API_URL); //
